module.exports = __webpack_public_path__ + "img/LaBase-Gnocchi-Sorrento-600px(2).e714042c.jpg";